import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
  showIcon?: boolean;
  scrollToSection?: boolean;
}
export function CTAButton({
  text = 'QUIERO ACCESO INMEDIATO',
  className = '',
  fullWidth = false,
  size = 'lg',
  showIcon = true,
  scrollToSection = false
}: CTAButtonProps) {
  const baseClasses = 'font-bold rounded-full shadow-[0_4px_0_rgb(180,83,9)] active:shadow-none active:translate-y-[4px] transition-all duration-150 flex items-center justify-center gap-2 uppercase tracking-wide';
  const sizeClasses = {
    md: 'py-3 px-6 text-base',
    lg: 'py-4 px-8 text-lg md:text-xl',
    xl: 'py-5 px-10 text-xl md:text-2xl'
  };
  const colorClasses = 'bg-yellow-400 hover:bg-yellow-300 text-slate-900 border-2 border-yellow-500';
  const handleClick = (e: React.MouseEvent) => {
    if (scrollToSection) {
      e.preventDefault();
      const purchaseSection = document.getElementById('purchase');
      if (purchaseSection) {
        purchaseSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  if (scrollToSection) {
    return <motion.button onClick={handleClick} className={`${baseClasses} ${sizeClasses[size]} ${colorClasses} ${fullWidth ? 'w-full' : 'w-auto'} ${className} cursor-pointer`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-179">
        {text}
        {showIcon && <ArrowRight className="w-6 h-6" strokeWidth={3} data-id="element-180" />}
      </motion.button>;
  }
  return <motion.a href="https://pay.hotmart.com/P104026694B?checkoutMode=10" target="_blank" rel="noopener noreferrer" className={`${baseClasses} ${sizeClasses[size]} ${colorClasses} ${fullWidth ? 'w-full' : 'w-auto'} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-181">
      {text}
      {showIcon && <ArrowRight className="w-6 h-6" strokeWidth={3} data-id="element-182" />}
    </motion.a>;
}